// Import necessary modules
import { React, useEffect, useState } from 'react';
import { Grommet, Card, CardHeader, Grid, Anchor, CardBody, CardFooter, Box, Text, Button, Image, Tab, Tabs } from 'grommet';
import { hpe } from 'grommet-theme-hpe';
import ReleaseSummary from './ReadMoreReadLess.js';
import { Bold } from 'grommet-icons';
import PropTypes from 'prop-types';
//import styled from 'styled-components';
import { useTranslation } from 'react-i18next';


const Ca = ({ }) => {
  const { t } = useTranslation(); 
}



const CADetailsGrid = ({ CAdata }) => {
    const { t } = useTranslation(); 
    return(
    <Grommet justifySelf="start" theme={hpe}>
        <Box justify="start" pad="medium">
            <Grid
                rows={['auto', ...(CAdata && CAdata.length > 0 ? CAdata.map(() => 'auto') : ['auto'])]} // Add an extra row for the "No data" message
                columns={['small', 'small', 'small', 'auto']}
                gap="small"
            >
                {/* Header Row */}
                <Text weight="bold">{t('Date')}</Text>
                <Text weight="bold">{t('CANumber')}</Text>
                <Text weight="bold">{t('FixedSPPVersion')}</Text>
                <Text weight="bold">{t('Description')}</Text>

                {/* Data Rows */}
                {CAdata && CAdata.length > 0 ? (
                    CAdata.map((item, index) => (
                        <>
                            <Text>{item.Date}</Text>
                            <Anchor href={item.CALink} target="_blank" rel="noopener noreferrer" label={item.CA} />
                            <Text>{item.FixedSPPVersion}</Text>
                            <Text>{item.Description}</Text>
                        </>
                    ))
                ) : (
                    <>
                        <Text gap="large" textAlign='center' gridColumn="span 4">{t('NoCAData')}</Text> 
                    </>
                )}
            </Grid>
        </Box>
    </Grommet>
); };


const CAComponent = ({ CAdata }) => {
    //const [isLeftAligned, setIsLeftAligned] = useState(true);

    // const toggleAlignment = () => {
    //     setIsLeftAligned(!isLeftAligned);
    // };

    
    console.log("CAComponent", CAdata);

    return (
        <Grommet theme={hpe}>

            <Box
            >
                <CADetailsGrid
                    CAdata={CAdata}

                />
            </Box>

        </Grommet>
    );
};


CAComponent.propTypes = {
    CAdata: PropTypes.arrayOf(
        PropTypes.shape({
            Date: PropTypes.string.isRequired,
            CA: PropTypes.string.isRequired,
            CALink: PropTypes.string.isRequired,
            FixedSPPVersion: PropTypes.string.isRequired,
            Description: PropTypes.string.isRequired
        })
    )
};
export default CAComponent;
